import { render, staticRenderFns } from "./ChamadosPesquisa.vue?vue&type=template&id=214e78e2&"
import script from "./ChamadosPesquisa.vue?vue&type=script&lang=js&"
export * from "./ChamadosPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./ChamadosPesquisa.vue?vue&type=style&index=0&id=214e78e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports